// Imports => Constants
import { KEYS } from '@constants';

// Imports => Utilities
import { AcCapitalize } from '@utils';

export const AcFormatErrorMessage = error => {
	let msg = false;
	let code =
		error && error.response && error.response.status
			? error.response.status
			: false;

	if (!code || code === 500) {
		return `Er is een onverwachte fout opgetreden en we hebben ons support team op de hoogte gesteld. Probeer het later nog eens of neem contact op met ${
			KEYS.SUPPORT_EMAIL_ADDRESS
		}`;
	}

	if (error.response && error.response.data && error.response.data.errors) {
		msg = [];

		for (let key in error.response.data.errors) {
			if (error.response.data.errors.hasOwnProperty(key)) {
				msg.push(AcCapitalize(error.response.data.errors[key][0]));
			}
		}

		msg = msg.join(', ');
	} else if (
		error.response &&
		error.response.data &&
		error.response.data.message
	) {
		msg = error.response.data.message;
	}

	return msg;
};

export const AcFormatErrorCode = error => {
	return error && error.response && error.response.status
		? error.response.status
		: 'Network Error';
};

export default {
	AcFormatErrorMessage,
	AcFormatErrorCode,
};
